import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AppService } from "src/app/app.service";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ModalPage } from "src/app/modals/modal/modal.page";

export interface Registration {
  Firstname: string;
  Surname: string;
  ID: string;
  Cellno: string;
  Email: string;
  Username: string;
  Password: string;
  CompanyName: string;
  CompanyRegNo: string;
  CompanyVatNo: string;
}

@Component({
  selector: "app-modal-registration",
  templateUrl: "./registrationModal.page.html",
  styleUrls: ["./registrationModal.page.scss"],
})
export class ModalPageRegistration implements OnInit {
  public cards: any = [];
  // personalDetails:FormGroup;
  // loginDetails:FormGroup;
  // companyDetails:FormGroup;
  registrationForm: FormGroup;

  public registration: Registration = {
    Firstname: "",
    Surname: "",
    ID: "",
    Cellno: "",
    Email: "",
    Username: "",
    Password: "",
    CompanyName: "",
    CompanyRegNo: "",
    CompanyVatNo: "",
  };

  paramObject: any;
  inputValue: string = "";

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private appservice: AppService
  ) {
    this.cards = [
      { Heading: "Personal Details", expanded: true, selected: true },
      { Heading: "Login credentials", expanded: true, selected: true },
      { Heading: "Company details", expanded: true, selected: true },
    ];
  }

  ngOnInit() {
    console.table(this.navParams);
    this.paramObject = this.navParams.data.paramObject;

    this.registrationForm = new FormGroup({
      FirstName: new FormControl("", Validators.required),
      Surname: new FormControl("", Validators.required),
      ID: new FormControl("", Validators.required),
      Cellno: new FormControl("", Validators.required),
      Email: new FormControl("", [Validators.required, Validators.email]),

      Username: new FormControl("", Validators.required),
      Password: new FormControl("", Validators.required),

      CompanyName: new FormControl("", Validators.required),
      CompanyRegNo: new FormControl("", Validators.required),
      CompanyVatNo: new FormControl("", Validators.required),
    });

    // this.registrationForm = new FormGroup(
    //   {
    //     personalDetails: new FormGroup({
    //       Firstname: new FormControl('', Validators.required),
    //       Surname: new FormControl('', Validators.required),
    //       ID: new FormControl('', Validators.required),
    //       Cellno: new FormControl('', Validators.required),
    //       Email: new FormControl('', Validators.required)
    //     }),
    //     loginDetails: new FormGroup({
    //       Username: new FormControl('', Validators.required),
    //       Password: new FormControl('', Validators.required)
    //     }),
    //     companyDetails: new FormGroup({
    //       CompanyName: new FormControl('', Validators.required),
    //       CompanyRegNo: new FormControl('', Validators.required),
    //       CompanyVatNo: new FormControl('', Validators.required)
    //     })
    //   });
  }

  onInputChange(event: any) {
    this.inputValue = event.target.value;
  }

  async onClose() {}

  expandAccordion(event: any) {
    var currentState = this.cards.find(
      (x) =>
        x.Heading == event.currentTarget.innerHTML.trim().replace("<!---->", "")
    ).expanded;

    this.cards.forEach((element) => {
      element.expanded = false;
      element.selected = false;
    });

    this.cards.find(
      (x) =>
        x.Heading == event.currentTarget.innerHTML.trim().replace("<!---->", "")
    ).expanded = !currentState;
    this.cards.find(
      (x) =>
        x.Heading == event.currentTarget.innerHTML.trim().replace("<!---->", "")
    ).selected = !currentState;
  }

  isExpanded(Heading: any) {
    if (this.cards.find((x) => x.Heading == Heading.trim()).selected) {
      return this.cards.find((x) => x.Heading == Heading.trim());
    }
  }
  public userCreated = false;

  async onRegister() {
    if (this.registrationForm.invalid) {
      this.promptModal("Error", "Required fields not filled in");
      return;
    }

    const formData: FormData = new FormData();
    formData.append("registration", JSON.stringify(this.registration));

    this.appservice.SaveRegistration(formData).subscribe((res) => {
      try {
        if (res == "User exist")
          this.promptModal("Username", "Username already taken");
        else if (res == "Success") {
          this.promptModal("Success", "Welcome to XRS");
          this.modalController.dismiss();
        } else {
          this.promptModal("Message", res.toString());
          this.modalController.dismiss();
        }
      } catch (e) {}
    });
  }

  async promptModal(modalHeaderText: string, modalBodyText: string) {
    var paramObject = {
      modalType: "Prompt",
      modalHeaderText: modalHeaderText,
      modalBodyText: modalBodyText,
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modals",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }
}
